module.exports = __webpack_public_path__ + "static/media/rgs_clinic_setup.8d417dc4.png";